export default __webpack_public_path__ + "static/media/yellowTheme-boy.ebabc433.svg";